'use strict';

// validation: store address got by KLARNA-GetAddresses
const savedAddress = {
    firstName: '',
    lastName: '',
    street: '',
    housenumber: '',
    city: '',
    zip: '',
    countryCode: ''
};

// SSN matching pattern
const patternSsn = '^\\s*([0-9][0-9][0-9]?[0-9]?)(0[1-9]|[12][0-9])(0[1-9]|[12][0-9]|3[01])\\s*(\.|\-|\/|\s)?\\s*([0-9][0-9][0-9][0-9])\\s*$';
const paymentKlarnaAddressIsValid = $('#js_klarna_valid_address');
const btnKlarnaAjaxGet = $('.js-klarna-ajax-button');
const btnKlarnaClearAll = $('.js-klarna-clearall-button');
const klarnaWaitIndicator = $('.js-klarna-loading-indicator');
const fieldKlarnaError = $('.js-klarna-error');

// address form field selectors
const fieldAddressList = $('select[name$="_singleshipping_addressList"]');
const fieldAddressSearch = $('input[name$="_shippingAddress_addressFields_addressSearch"]');
const fieldSsn = $('input[name$="_shippingAddress_addressFields_ssn"]');
const fieldFirstName = $('input[name$="_shippingAddress_addressFields_firstName"]');
const fieldLastName = $('input[name$="_shippingAddress_addressFields_lastName"]');
const fieldStreet = $('input[name$="_shippingAddress_addressFields_street"]');
const fieldHouseNumber = $('input[name$="_shippingAddress_addressFields_houseNumber"]');
const fieldZip = $('input[name$="_shippingAddress_addressFields_postal"]');
const fieldCity = $('input[name$="_shippingAddress_addressFields_city"]');
const fieldCountry = $('select[name$="_shippingAddress_addressFields_country"]');
const fieldsUseAsBilling = $('input[name$="_shippingAddress_useAsBillingAddress"]');
const labelUseAsBilling = $('label[for$="_shippingAddress_useAsBillingAddress"]');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {
    // handle the klarna address check button click
    btnKlarnaAjaxGet.on('click', function(e) {
        e.preventDefault();
        requestAddressToKlarna();
    });

    // handle the klarna clear all button click
    btnKlarnaClearAll.on('click', function(e) {
        e.preventDefault();
        clearKlarnaData();
    });

    // toggle the klarna address check button on ssn field changes
    fieldSsn.on('keyup paste change input blur', function(e) {
        toggleSsnButton(e);
    });

    // Updating klarna validation in every change on inputs or texts
    $('.input-text,input-select').change(function() {

        if (fieldFirstName.val() == savedAddress.firstName
                && fieldLastName.val() == savedAddress.lastName
                && fieldStreet.val() == savedAddress.street
                && fieldHouseNumber.val() == savedAddress.housenumber
                && fieldCity.val() == savedAddress.city
                && fieldZip.val().replace(' ', '') == savedAddress.zip.replace(' ', '')) {
            paymentKlarnaAddressIsValid.val('1');
        } else {
            paymentKlarnaAddressIsValid.val('0');
        }
    });

    const ssnUsed = $('#js_klarna_ssn_used');
    if (ssnUsed.val() != undefined && ssnUsed.val() != '') {
        fieldSsn.val(ssnUsed.val());
        btnKlarnaAjaxGet.addClass('hide');
        paymentKlarnaAddressIsValid.val('1');
        lockKlarnaRelatedFields();
    }
};

/**
 * request address data from KLARNA GetAddresses service for swedish customers
 */
function requestAddressToKlarna() {
    paymentKlarnaAddressIsValid.val('0');

    // try to match a valid personnummer (ssn)
    let ssn = fieldSsn.val();
    const pattern = new RegExp(patternSsn);
    if (pattern.test(ssn)) {
        ssn = ssn.replace(pattern, '$1$2$3-$5');
        fieldSsn.val(ssn);
    }

    // get url for the GetAddresses service from the KlarnaPayment cartridge
    const url = Urls.klarnaGetAddress;
    const data = {'ssn': ssn};

    //hide button, show wait message
    btnKlarnaAjaxGet.addClass('hide');
    klarnaWaitIndicator.removeClass('hide');

    $.get(url, data, function (response) {
        if (!response.success) {
            // display ssn validation error information if it is one
            fieldSsn.addClass('error');
            fieldKlarnaError.removeClass('hide');
            btnKlarnaAjaxGet.removeClass('hide');
        } else {
            // if first_name doesn't exist in xml data, assume it is company
            if (response.addresses && (response.addresses.length > 0) && response.addresses[0].fname) {
                // store address for validation
                savedAddress.firstName = response.addresses[0].fname;
                savedAddress.lastName = response.addresses[0].lname;
                savedAddress.street = response.addresses[0].street;
                savedAddress.housenumber = response.addresses[0].housenumber;
                savedAddress.city = response.addresses[0].city;
                savedAddress.zip = response.addresses[0].zip;
                savedAddress.countryCode = response.addresses[0].country;

                lockKlarnaRelatedFields();

                fieldSsn.removeClass('error');
                fieldFirstName.val(savedAddress.firstName).removeClass('error');
                fieldFirstName.trigger('change');
                fieldLastName.val(savedAddress.lastName).removeClass('error');
                fieldLastName.trigger('change');
                fieldStreet.val(savedAddress.street).removeClass('error');
                fieldStreet.trigger('change');
                fieldHouseNumber.val(savedAddress.housenumber).removeClass('error');
                fieldHouseNumber.trigger('change');
                fieldZip.val(savedAddress.zip).removeClass('error');
                fieldZip.trigger('change');
                fieldCity.val(savedAddress.city).removeClass('error');
                fieldCity.trigger('change');
                fieldCountry.removeClass('error');
                fieldCountry.trigger('change');

                fieldKlarnaError.removeClass('error');
                fieldKlarnaError.addClass('hide');
            } else {
                fieldSsn.addClass('error');
                btnKlarnaAjaxGet.removeClass('hide');
                fieldKlarnaError.removeClass('hide');
            }
        }

    })
    .fail(function () {
        fieldSsn.addClass('error');
        btnKlarnaAjaxGet.removeClass('hide');
        fieldKlarnaError.removeClass('hide');
    })
    .always(function() {
        klarnaWaitIndicator.addClass('hide');
    });
}

/**
 * Toggle the ssn address check button
 * enable / disable it depending on the ssn field context
 */
function toggleSsnButton(e) {
    if (e.keyCode != 91 && e.keyCode != 93 && e.keyCode != 18 && e.keyCode != 16 && e.keyCode != 17 && e.keyCode != 27 && e.keyCode != 13 && e.keyCode != 37 && e.keyCode != 38 && e.keyCode != 39 && e.keyCode != 40) {
        const ssn = fieldSsn.val();
        const pattern = new RegExp(patternSsn);

        if (pattern.test(ssn)) {
            btnKlarnaAjaxGet.removeAttr('disabled');
        } else {
            btnKlarnaAjaxGet.attr('disabled', 'disabled');
        }
        fieldKlarnaError.addClass('hide');
    }
}

/**
 * Handle the clear all functionality
 *
 */
function clearKlarnaData() {
    // get url for the GetAddresses service from the KlarnaPayment cartridge
    const url = Urls.removeSSNFromSession;

    $.get(url, function (response) {
        if (response.success) {
            fieldSsn.val('').change(); //trigger input 'change' event to toggle button state
            fieldFirstName.val('');
            fieldLastName.val('');
            fieldStreet.val('');
            fieldHouseNumber.val('');
            fieldZip.val('');
            fieldCity.val('');

            // disable all input fields on successful validation
            fieldAddressList.removeAttr('disabled');
            fieldAddressSearch.removeAttr('readonly');
            fieldSsn.removeAttr('readonly');
            fieldFirstName.removeAttr('readonly');
            fieldLastName.removeAttr('readonly');
            fieldStreet.removeAttr('readonly');
            fieldHouseNumber.removeAttr('readonly');
            fieldZip.removeAttr('readonly');
            fieldCity.removeAttr('readonly');
            fieldCountry.removeAttr('disabled');
            fieldsUseAsBilling.removeClass('hide');
            labelUseAsBilling.removeClass('hide');

            //disable klarna button and use as billing address and google places field, enable clear all button
            btnKlarnaAjaxGet.removeClass('hide');
            btnKlarnaClearAll.addClass('hide');
            fieldKlarnaError.addClass('hide');
        }
    });
}

function lockKlarnaRelatedFields () {
    // disable all input fields on successful validation
    // TODO : address selection dropdown
    fieldAddressList.attr('disabled', 'disabled');
    fieldAddressSearch.attr('readonly', 'readonly');
    fieldSsn.attr('readonly', 'readonly');
    fieldFirstName.attr('readonly', 'readonly');
    fieldLastName.attr('readonly', 'readonly');
    fieldStreet.attr('readonly', 'readonly');
    fieldHouseNumber.attr('readonly', 'readonly');
    fieldZip.attr('readonly', 'readonly');
    fieldCity.attr('readonly', 'readonly');
    fieldCountry.attr('disabled', 'disabled');
    fieldsUseAsBilling.addClass('hide');
    labelUseAsBilling.addClass('hide');

    //disable use as billing address and google places field, enable clear all button
    btnKlarnaClearAll.removeClass('hide');
    fieldsUseAsBilling.prop('checked', true).trigger('change');

    // flag a valid address
    paymentKlarnaAddressIsValid.val('1');

    // validate Klarna fields
    fieldFirstName.valid();
    fieldLastName.valid();
    fieldStreet.valid();
    fieldHouseNumber.valid();
    fieldZip.valid();
    fieldCity.valid();
    fieldCountry.valid();

    fieldSsn.parent().children('span.error').hide();
    fieldFirstName.parent().children('span.error').hide();
    fieldLastName.parent().children('span.error').hide();
    fieldStreet.parent().children('span.error').hide();
    fieldHouseNumber.parent().children('span.error').hide();
    fieldZip.parent().children('span.error').hide();
    fieldCity.parent().children('span.error').hide();
    fieldCountry.parent().children('span.error').hide();
}
